const BASE_URL  = 'https://prebuilt-queries-api-enegcvffddabawg3.canadacentral-01.azurewebsites.net';
const ADMIN_KEY = '1f4ded46b4401231b6899172dac6b83c961d86301e059d6c1c6fa2542ca942a9';

async function request(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json', 'x-admin-key': ADMIN_KEY };

  if (auth) {
    const token = localStorage.getItem('token');
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }

  const options = { method, headers };
  if (body !== undefined) options.body = JSON.stringify(body);

  const res = await fetch(`${BASE_URL}${path}`, options);

  if (res.status === 401 && auth) {
    localStorage.removeItem('token');
    window.location.reload();
    return;
  }

  if (res.status === 204) return null;

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    const message = data?.error || `Request failed: ${res.status} ${res.statusText}`;
    throw new Error(message);
  }

  return data;
}

// QUERIES
export function fetchAllQueries() {
  return request('/api/admin/queries');
}

export function fetchQueryById(id) {
  return request(`/api/admin/queries/${id}`);
}

export function createQuery(data) {
  return request('/api/admin/queries', { method: 'POST', body: data });
}

export function updateQuery(id, data) {
  return request(`/api/admin/queries/${id}`, { method: 'PUT', body: data });
}

export function deleteQuery(id) {
  return request(`/api/admin/queries/${id}`, { method: 'DELETE' });
}

// VERSIONS
export function addVersion(queryId, data) {
  return request(`/api/admin/queries/${queryId}/versions`, { method: 'POST', body: data });
}

export function updateVersion(queryId, versionId, data) {
  return request(`/api/admin/queries/${queryId}/versions/${versionId}`, { method: 'PUT', body: data });
}

export function deleteVersion(queryId, versionId) {
  return request(`/api/admin/queries/${queryId}/versions/${versionId}`, { method: 'DELETE' });
}

// CATEGORIES
export function fetchCategories() {
  return request('/api/admin/categories');
}

export function createCategory(name) {
  return request('/api/admin/categories', { method: 'POST', body: { name } });
}

export function createSubcategory(categoryId, name) {
  return request(`/api/admin/categories/${categoryId}/subcategories`, { method: 'POST', body: { name } });
}

// AUTH
export async function login(username, password) {
  const data = await request('/api/auth/login', { method: 'POST', body: { username, password }, auth: false });
  return data.token;
}

// BI CONNECTOR
export function fetchLatestQueries() {
  return request('/api/queries');
}
